

// const MyActionInitiator: React.FC = () => {
//   return (
//     <div>
//       <h2>My Action Initiator</h2>
//       <p>This is a simple action initiator component.</p>
//     </div>
//   );
// };

// export default MyActionInitiator;

import * as React from "react";
import { useState, useEffect, useContext, useCallback } from "react";
import {
  AppBar,
  Typography, Box,
  Breadcrumbs,
  Link
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { PageDataContext } from "../../utils/common/PageDataContext";
import { ViewMyActionInitiator } from "../../components/grid/GridDataGrn";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { externalgetApi } from "../../services/externalApis";
import { useSelector } from "react-redux";
import { GRN_API_02, GRN_API_02_2, GRN_API_17 } from "../../api/ApiModel";
import { CON_STATUS_RETURNSAVED, CON_TRSTS_RETURN, CON_YES } from "../../utils/sys/Constants";
import { FormatDate } from "../../utils/common/DateUtils";
import { AnyForNow, GrnFilterState } from "./types";
import { BUTTON_LABELS, GRN_BREADCRUMBS, PAGE_TITLES } from "../../utils/sys/GrnLabels";
import { GRN_ROUTES } from "../../utils/sys/GrnRoutes";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import {
  GRN_INITIATOR_FILTER,
  GRN_RETURN_APPROVAL_FILTER,
  GRN_RETURN_STATUS,
  GRN_STATUS, GRN_VIEW_RETURN_FILTER, MYACTION_INITIATOR_FILTER,
  PARAM_ID
} from "../../utils/sys/GrnConstants";
import {
  createInitialFilters,
  useGrnStatusTypes,
  useWarehouseOptions,
} from "./hooks/useGrnFilters";
import ViewDataGridGrnInitiator from "../../components/grid/ViewDataGridGrnInitiator";
import FilterMyActionSearch from "../../components/grn/FilterMyActionSearch";
import { SEARCH_FIELDS_MYACTIONS } from "../../utils/sys/GrnSearchFeilds";

const MyActionInitiator: React.FC = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const SYS_USER = useSelector((state: AnyForNow) => state.user) || {};
  const { STAFFMAPLOCODE, COMPCODE } = SYS_USER.USER_PARAM || {};
  const [allData, setAllData] = useState<AnyForNow[]>([]);
  const [allfullData, setAllfullData] = useState<AnyForNow[]>([]);
  const [filteredRows, setFilteredRows] = useState<AnyForNow[]>([]);
  const [filteredfullRows, setFilteredfullRows] = useState<AnyForNow[]>([]);
  const [actionTypeOptions, setActionTypeOptions] = useState<AnyForNow[]>([
    { value: "GRN", label: "GRN" },
    { value: "Return", label: "Return" },
  ]);
  const moduleParamJson = useSelector((state: AnyForNow) => state.moduleParamJson);
  const moduleParamJsonArray = Array.isArray(moduleParamJson)
    ? moduleParamJson
    : Object.values(moduleParamJson || {});
  const shouldIncludeAll = moduleParamJsonArray.some(
    (item) => item.PARAID === PARAM_ID.APPROVAL_WORKFLOW && item.PARAVALUE === CON_YES
  );
  const warehouseOptions = useWarehouseOptions(COMPCODE);
  const mainStatusesWithApproval =
    MYACTION_INITIATOR_FILTER.MAIN_STATUSES_WITH_APPROVAL as readonly string[];
  const mainStatusesDefault =
    MYACTION_INITIATOR_FILTER.MAIN_STATUSES_DEFAULT as readonly string[];

  const statusFilter = useCallback(
    (item: AnyForNow) => {
   
      if (shouldIncludeAll) {
           return mainStatusesWithApproval.includes(String(item.trsts));
         }
         return mainStatusesDefault.includes(String(item.trsts));
    },
    [ shouldIncludeAll]
  );
  const { statusTypes: grnStatusTypes } = useGrnStatusTypes({
    filter: statusFilter,
    deps: [statusFilter],
  });
  const [filters, setFilters] = useState<GrnFilterState>(createInitialFilters());
  useEffect(() => {
    setPageData({
      title: PAGE_TITLES.MY_ACTIONS,
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, [setPageData]);

const handleItemClick = (
  grncode: string,
  trsts: string,
  pocode: string,
  actionText: string,
  grnreturncode?: string,
 returneddate?: string
): void => {
  if (
    actionText === BUTTON_LABELS.EDIT &&
    trsts === GRN_VIEW_RETURN_FILTER.RETURN_DEFAULT_STATUS
  ) {
    navigate(GRN_ROUTES.EDIT_RETURN, {
      state: { grncode, trsts, statusCode: trsts,origin: GRN_VIEW_RETURN_FILTER.ORIGIN_EDIT_RETURN, grnreturncode, returneddate },
    });
  } else if (actionText === BUTTON_LABELS.EDIT) {
    navigate(GRN_ROUTES.EDIT, {
      state: { grncode, trsts, pocode,origin: GRN_VIEW_RETURN_FILTER.ORIGIN_EDIT_RETURN },
    });
  }
};

const [loading, setLoading] = useState<boolean>(true);
const hasFetchedGrnListRef = React.useRef(false);
const grnStatusTypesRef = React.useRef<AnyForNow[]>([]);

// Update ref when grnStatusTypes changes
React.useEffect(() => {
  grnStatusTypesRef.current = grnStatusTypes;
}, [grnStatusTypes]);

// Optimized: Single API call that processes data for both filtered and full lists
const fetchGrnListData = useCallback(async (): Promise<void> => {
  if (!COMPCODE || !STAFFMAPLOCODE) {
    return;
  }

  // Prevent duplicate calls
  if (hasFetchedGrnListRef.current) {
    return;
  }

  try {
    hasFetchedGrnListRef.current = true;

  const result = await externalgetApi(GRN_API_02, "GET", {
  COMPCODE,
  LOCCODE: STAFFMAPLOCODE,
   
});

const filteredResult_1 = Array.isArray(result)
  ? result.filter((item) => String(item.trcatcode) === "1")
  : [];

console.log("Fetched GRN List Data:", result);

const result_2 = await externalgetApi(GRN_API_17, "GET", {
  COMPCODE,
  LOCCODE: STAFFMAPLOCODE,
  TRCATCODE: CON_TRSTS_RETURN,
});

const filteredResult = Array.isArray(result_2)
  ? result_2.filter((item) => String(item.trsts) === CON_STATUS_RETURNSAVED)
  : [];

  console.log("f2",filteredResult)
const availableActionTypes = [
  ...(filteredResult_1.length > 0 ? [{ value: "GRN", label: "GRN" }] : []),
  ...(filteredResult.length > 0 ? [{ value: "Return", label: "Return" }] : []),
];

setActionTypeOptions(availableActionTypes.length > 0 ? availableActionTypes : [
  { value: "GRN", label: "GRN" },
  { value: "Return", label: "Return" },
]);

// Tag origin explicitly instead of relying on item.trcatcode from the API
const grnRows = filteredResult_1.map((item) => ({
  ...item,
  __actionType: "GRN",
}));

const returnRows = filteredResult.map((item) => ({
  ...item,
  __actionType: "Return",
}));

const combinedResult = [...grnRows, ...returnRows];

    console.log("Combined GRN List Data:", combinedResult);

    if (combinedResult.length === 0) {
      setFilteredRows([]);
      setLoading(false);
      return;
    }

    const shouldIncludeAll =
      moduleParamJsonArray.filter((item) => item.PARAID === PARAM_ID.APPROVAL_WORKFLOW)[0]
        ?.PARAVALUE === CON_YES;

    // Process the combined data once
    const processedData = combinedResult.map((item, index) => {
      const matchedStatus = grnStatusTypesRef.current.find(
        (status) => String(status.trsts) === String(item.trsts)
      );

    

      return {
        ...item,
       id: `${item.__actionType}-${item.grncode || "x"}-${item.grnreturncode || "x"}-${index}`,
        invoicedate: FormatDate(item.invoicedate),
        endate: FormatDate(item.endate),
        statusLabel: matchedStatus?.trenuserremark || GRN_BREADCRUMBS.STATUS_FALLBACK,
        statusColor:
          matchedStatus?.colorcode || GRN_INITIATOR_FILTER.STATUS_FALLBACK_COLOR,
        invoicedateRaw: item.invoicedate,
        endateRaw: item.endate,
        pocode: item.pocode,
        grnstatuscode: item.trsts,
        Supplier: `${item.suprefcode} - ${item.suppliername}`,
                                   // keep original for filtering
  trcatcode: item.__actionType,      
  grncode: item.grncode || "-", // keep original for filtering
  grnreturncode: item.grnreturncode || "-", // keep original for filtering
 // keep original for filtering


      };
    });

 // Filter for main list - stricter filter
    const filteredForMain = processedData.filter((item) => {
      if (shouldIncludeAll) {
        return mainStatusesWithApproval.includes(String(item.trsts));
      } else {
        return mainStatusesDefault.includes(String(item.trsts));
      }
    });

    setAllfullData(filteredForMain);   // <-- feed the filter pipeline
    setFilteredRows(filteredForMain);  // <-- keep as the pre-filter baseline (optional)
  } catch (err) {
    console.error("Error fetching GRN list data:", err);
    hasFetchedGrnListRef.current = false;
  } finally {
    setLoading(false);
  }
}, [COMPCODE, STAFFMAPLOCODE, moduleParamJsonArray]);

useEffect(() => {
  // Only fetch when status types are loaded (needed for status matching) and we haven't fetched yet
  if (grnStatusTypes.length > 0 && !hasFetchedGrnListRef.current && COMPCODE && STAFFMAPLOCODE) {
    fetchGrnListData();
  }
}, [fetchGrnListData, grnStatusTypes.length, COMPCODE, STAFFMAPLOCODE]);



useEffect(() => {
  if (!allfullData.length) {
    setFilteredfullRows([]);
   
    return;
  }

  let filtered = allfullData;

  const searchValue = String(filters.searchValue || filters.grnId || "").trim().toLowerCase();
  if (searchValue) {
    filtered = filtered.filter((item) => {
      const grnCode = String(item.grncode || "").toLowerCase();
      const returnCode = String(item.grnreturncode || "").toLowerCase();
       const supplierName = String(item.suppliername || "").toLowerCase();
       const supplierCode = String(item.suprefcode || "").toLowerCase();
      return grnCode.includes(searchValue) || returnCode.includes(searchValue) || supplierName.includes(searchValue) || supplierCode.includes(searchValue);
    });
  }

if (filters.warehouse) {
  filtered = filtered.filter(
    (item) => String(item.restcode) === String(filters.warehouse)
  );
}

 if (filters.actionType) {
    filtered = filtered.filter(
      (item) => String(item.trcatcode) === String(filters.actionType)
    );
  }

  if (filters.status) {
    filtered = filtered.filter(
      (item) => String(item.grnstatuscode) === String(filters.status)
    );
  }

 if (filters.fromDate && filters.toDate) {
  const from = new Date(filters.fromDate);
  const to = new Date(filters.toDate);

  const start = from < to ? from : to;
  const end = from < to ? to : from;

  filtered = filtered.filter(
    (item) => {
      const date = new Date(item.invoicedateRaw || item.endateRaw);
      return date >= start && date <= end;
    }
  );
} else if (filters.fromDate) {
  const from = new Date(filters.fromDate);
  filtered = filtered.filter(
    (item) => new Date(item.invoicedateRaw) >= from
  );
} else if (filters.toDate) {
  const to = new Date(filters.toDate);
  filtered = filtered.filter(
    (item) => new Date(item.endateRaw) <= to
  );
}


  setFilteredfullRows(filtered);
}, [filters, allfullData]);

  const handleFilterChange = (newFilters: GrnFilterState): void => {
    setFilters(newFilters);
  };

const menuItems = [
  {
    text: BUTTON_LABELS.PROCEED,
    icon: <ArrowCircleRightIcon />,
    onClick: (row: AnyForNow) =>
      handleItemClick(row.grncode, row.trsts, row.pocode, BUTTON_LABELS.EDIT,row.grnreturncode, row.returneddate),
  },
];



  return (
    <>
      <Box sx={styles.box_breadcrumb_view}>
        <Breadcrumbs
          separator={GRN_BREADCRUMBS.SEPARATOR}
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            {GRN_BREADCRUMBS.HOME}
          </Link>
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            {GRN_BREADCRUMBS.MY_ACTIONS}
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
            {GRN_BREADCRUMBS.MYACTION_INITIATOR}
          </Link>
        </Breadcrumbs>
      </Box>

      <Box sx={styles.box_page_container}>
        <AppBar sx={styles.vg_appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              size={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {ViewMyActionInitiator.name}
              </Typography>
            </Grid>

            <Grid size={{ xs: 8, sm: 8, md: 8, lg: 8, xl: 8 }}>
              <Box
                sx={{
                  gap: 1,
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                  alignItems: "center",
                }}
              >
              
              </Box>
            </Grid>
            
          </Grid>
        </AppBar>
   
        <FilterMyActionSearch
          warehouseOptions={warehouseOptions}
          grnStatusTypes={grnStatusTypes}
          onFilterChange={handleFilterChange}
          actionTypeOptions={actionTypeOptions}
           searchFields={SEARCH_FIELDS_MYACTIONS}
        />

        <Box sx={styles.view_page_container}>
         <ViewDataGridGrnInitiator
  columns={ViewMyActionInitiator.columns}
  rows={filteredfullRows}   // <-- was filteredRows
  menuItems={menuItems}
  tabletitle={ViewMyActionInitiator.name}
  gridid={GRN_INITIATOR_FILTER.GRID_ID}
  sx={styles.view_data_grid_page}
  grnStatusTypes={grnStatusTypes}
  onSelectionChange={undefined}
  grnReturnStatusTypes={undefined}
  selectionModel={undefined}
  loading={loading}
  showCheckbox={false}
/>

        </Box>
      </Box>
    </>
  );
};

export default MyActionInitiator;
